import './App.css';
import "./bootstrap.min.css"
import Home from './screens/Home';
import { Routes, Route, Navigate } from 'react-router-dom';

import LoginScreen from "./AdminScreens/LoginScreen";
import BlogsScreen from "./AdminScreens/BlogsScreens/BlogsScreen";
import AdminScreen from "./AdminScreens/AdminScreen";
import NotFound from "./screens/NotFound"
import LocationScreen from './screens/LocationScreens/LocationScreen';
import LocationPages from "./component/LocationPages_/LocationPages"
import ThankYou from './screens/ThankYou';
import About from './screens/About';
import Services from './screens/Services';
import Contact from './screens/Contact';
import Blog from './screens/Blog';
import BlogInner from './screens/BlogInner';


function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Navigate to="/" replace={true}/>} />
        <Route path="/about" element={<About />} />
        <Route path="/what-we-treat" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:id" element={<BlogInner />} />

       
        <Route path="/admin" element={<AdminScreen />} />
        <Route path="/admin/blogs" element={<BlogsScreen />} />
        <Route path="/login" element={<LoginScreen />} />
        
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="*" element={<NotFound />} />

        
        <Route path='/location/:slug' element={<LocationPages />} />
        <Route path='/admin/location-pages' element={<LocationScreen />}/>
      </Routes>
    </div>
  );
}

export default App;


